import React from 'react';
import Lottie from 'react-lottie';

export const Diggy = {
    Aaahshit,
    Ain,
    Angry,
    Baby,
    Baidald_oroh,
    Bavaan,
    Booty_dance,
    Boxing,
    Bujigchin,
    Bysalgal,
    Cleanclap,
    Coffetime,
    Congrats,
    Cry,
    Deal,
    DiggyReal,
    Duu_aylah,
    Face_okey,
    Fat,
    Fuckyou,
    Haha,
    Haluunnogoo,
    Handjob,
    Julh2,
    Listenmusic,
    Manraa,
    Merlinmonara,
    Muahaha,
    Pllll,
    Showman,
    Ut,
    Uuchlaarai,
    Yoooy,
    Yuuuvee,
}
export const DiggyJson = [
    {id: 1, type: Aaahshit},
    {id: 2, type: Ain},
    {id: 3, type: Angry},
    {id: 4, type: Baby},
    {id: 5, type: Baidald_oroh},
    {id: 6, type: Bavaan},
    {id: 7, type: Booty_dance},
    {id: 8, type: Boxing},
    {id: 9, type: Bujigchin},
    // {id: 10, type: Bysalgal},
    {id: 11, type: Cleanclap},
    {id: 12, type: Coffetime},
    {id: 13, type: Congrats},
    {id: 14, type: Cry},
    {id: 15, type: Deal},
    {id: 16, type: DiggyReal},
    {id: 17, type: Duu_aylah},
    {id: 18, type: Face_okey},
    {id: 19, type: Fat},
    // {id: 20, type: Fuckyou},
    {id: 21, type: Haha},
    {id: 22, type: Haluunnogoo},
    {id: 23, type: Handjob},
    {id: 24, type: Julh2},
    {id: 25, type: Listenmusic},
    {id: 26, type: Manraa},
    {id: 27, type: Merlinmonara},
    {id: 28, type: Muahaha},
    {id: 29, type: Pllll},
    {id: 30, type: Showman},
    {id: 31, type: Ut},
    {id: 32, type: Uuchlaarai},
    {id: 33, type: Yoooy},
    {id: 34, type: Yuuuvee}
];

function Aaahshit() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/aaahshit.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Ain() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/ain.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Angry() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/angry.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Baby() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/baby.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Baidald_oroh() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/baidald_oroh.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}

function Bavaan() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/bavaan.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Booty_dance() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/booty_dance.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Boxing() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/boxing.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Bujigchin() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/bujigchin.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}

function Bysalgal() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/bysalgal.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Cleanclap() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/cleanclap.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Coffetime() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/coffetime.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}

function Congrats() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/congrats.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Cry() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/cry.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Deal() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/deal.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function DiggyReal() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/diggy.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Duu_aylah() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/duu_aylah.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Face_okey() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/face_okey.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Fat() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/fat.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Fuckyou() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/fuckyou.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Haha() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/haha.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Haluunnogoo() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/haluunnogoo.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Handjob() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/handjob.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Julh2() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/julh2.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Listenmusic() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/listenmusic.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Manraa() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/manraa.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Merlinmonara() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/merlinmonara.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Muahaha() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/muahaha.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Pllll() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/pllll.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Showman() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/showman.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Ut() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/ut.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Uuchlaarai() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/uuchlaarai.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Yoooy() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/yoooy.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}
function Yuuuvee() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require('../../static/diggy/yuuuvee.json'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return <Lottie options={defaultOptions} height={200} width={200}/>
}


